import { Icon } from 'components/common';
import useProfileEdit from 'hooks/profile/useProfileEdit';

const ProfileEdit = () => {
  const {
    profileImageUrl,
    nick,
    nickStatus,
    uploadButtonRef,
    handleUploadPhoto,
    goToPage,
    close
  } = useProfileEdit();
  const isRTL = BResource.isRTL();

  return (
    <>
      <div>
        <div className="fixed inset-0 flex flex-col overflow-hidden px-4">
          {/* 상단 헤더 */}
          <div className="mb-2 flex h-14 w-full items-center justify-between py-2">
            <Icon name="profile/close.svg" size={24} onClick={() => close('ProfileEdit')} />
            <div className="typography-title-md text-center text-base-txt-primary">{brsc.edit_profile}</div>
            <div className="w-[24px]"></div>
          </div>

          {/* 사진 영역 */}
          <div className="flex flex-col items-center gap-2">
            <div ref={uploadButtonRef} onClick={handleUploadPhoto}>
              {profileImageUrl && !profileImageUrl.includes('default') ? (
                <div className="itmes-center flex h-[120px] w-[120px] justify-center">
                  <img alt="" src={profileImageUrl} className="aspect-square h-full w-full rounded-xl" />
                </div>
              ) : (
                <div className="flex h-[120px] w-[120px] items-center justify-center rounded-xl bg-base-bg-subtle p-8">
                  <Icon name="profile/camera.svg" className="aspect-square" size={52} />
                </div>
              )}
            </div>
            <div
              onClick={handleUploadPhoto}
              className="typography-headline-sm my-1 flex items-center justify-center rounded-full border border-solid border-[#585870] px-3 py-2 text-base-txt-primary"
            >
              {brsc.change_photo}
            </div>
          </div>

          <hr className="mb-6 mt-4 h-[1px] w-full border-solid border-[#585870]" />

          {/* Name && Region */}
          <div className="flex w-full flex-col items-center gap-4">
            <div
              onClick={() => goToPage(Def.PAGE_EDITNICK)}
              className={`flex w-full items-center gap-4 rounded-lg bg-base-bg-subtle px-4 py-3 ${nickStatus === 'inspecting' ? 'pointer-events-none' : ''}`}
            >
              <div className={`flex flex-1 flex-col items-start gap-1 ${nickStatus === 'inspecting' ? 'opacity-50' : ''}`}>
                <div className="typography-caption-body text-base-txt-tertiary">{brsc.profile_basicinfo_name}</div>
                <div className="typography-headline-lg text-base-txt-primary">{nick || myinfo.nick}</div>
              </div>
              {nickStatus === 'inspecting' ? (
                <div className="typography-caption-body flex items-center justify-center rounded-full bg-base-bg-focus px-2 py-1 text-base-txt-inverse">{brsc.requested}</div>
              ) : (
                <Icon name="profile/right.svg" size={24} className={isRTL ? 'scale-x-[-1]' : ''} />
              )}
            </div>
            <div onClick={() => goToPage(Def.PAGE_MEMBERSHIP_LOCALE)} className="flex w-full items-center gap-4 rounded-lg bg-base-bg-subtle px-4 py-3">
              <div className="flex flex-1 flex-col items-start gap-1">
                <div className="typography-caption-body text-base-txt-tertiary">{brsc.region}</div>
                <div className="typography-headline-lg text-base-txt-primary">{getCountryName(myinfo.country)}</div>
              </div>
              <Icon name="profile/right.svg" size={24} className={isRTL ? 'scale-x-[-1]' : ''} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileEdit;
